export default __webpack_public_path__ + "static/media/thaigo-screenshot-05.87d15a90.png";